import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { EntitlementsService } from '../../services/entitlements.service';
import { SnackbarService } from '../../services/snackbar.service';
import { UserActions } from '../../store/user/user.actions';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css'],
  standalone: true,
  imports: []
})
export class VerifyEmailComponent {

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private entitlementsService: EntitlementsService,
    private snackBarService: SnackbarService,
    private store: Store,
    private actions$: Actions
  ) { }
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      // This occurs when user comes from invited route.

      const email = decodeURIComponent(params['email'])
      const code = params['code']
      const redirect = params['redirect']

      if (email && code) {
        this.store.dispatch(UserActions.VERIFY_SIGNUP({ email: email, confirmationCode: code }));

        this.actions$.pipe(ofType(UserActions.VERIFY_SIGNUP_SUCCESS), take(1)).subscribe((data) => {
          this.snackBarService.openSnackBar('Email successfully verified', undefined);
          if (!redirect || redirect == "undefined") {
            this.router.navigate(['/login'],
              {
                queryParams: {
                  email: btoa(email)
                }
              }
            );
          }
          else {
            this.router.navigate(['/login'], {
              queryParams: {
                redirect: redirect,
                email: btoa(email)
              }
            })
          }

        })
        this.actions$.pipe(ofType(UserActions.VERIFY_SIGNUP_FAILED), take(1)).subscribe((data) => {
          this.snackBarService.openSnackBar('Email verification failed', undefined);
          this.router.navigate(['signup'], {
            queryParams: {
              email: email
            }
          });
        })
      }

    })

  }
}
